export default __webpack_public_path__ + "static/media/7.7e23bbe0.png";